module.exports = angular.module('rails', ['ngResource'])
.config(['$httpProvider', ($httpProvider) ->
  $httpProvider.interceptors.push('railsHttpInterceptor')
])
.factory('railsResource', ['$resource', ($resource) ->
  (url, paramDefaults = {}, actions = {}, config = {}) ->
    defaultConfig = {
      rails: true,
      resourceException: true,
      camelizeResponse: true,
      snakeizeRequest: true,
    }
    defaultActions =
      create: {method: 'POST'}
      update: {method: 'PUT'}
      get:    {method:'GET'}
      save:   {method:'POST'}
      query:  {method:'GET', isArray:true}
      remove: {method:'DELETE'}
      delete: {method:'DELETE'}

    _.defaults(actions, defaultActions)
    _.defaults(config, defaultConfig)
    _.each actions, (action) ->
      action.url = '/api' + action.url if action.url
      _.defaults(action, config)
    url = '/api' + url
    $resource(url, paramDefaults, actions, config)
]).factory('railsHttpInterceptor', ['$q', '$rootScope', ($q, $rootScope) ->
  return {
    request: (config) ->
      if config?.rails && config?.snakeizeRequest
        config = _.cloneDeep(config)
        config.params = _.snakeize(config.params)
        config.data = _.snakeize(config.data)
      config

    response: (response) ->
      if response?.config?.rails and response?.config?.camelizeResponse
        response.data = _.camelize(response.data)
      response

    responseError: (response) ->
      if response?.config?.rails and response?.config?.resourceException
        $rootScope.$broadcast 'resourceException', response
      $q.reject response
  }
])
